import { useDispatch } from "react-redux"
import { TextInputField, DropDownField } from "../../../../helpers"
import { raiseToast } from "../../../../services/redux/reducers/toast/toast"


const NegativeAdjDisplay = (props) => {

    const { sellerPOs, GSTRates, handleSellerPOsChange } = props

    const dispatch = useDispatch()

    const handleAdjustedQtyChange = (id, e, sellerPOItemQty) => {
        let updatedValue = e.target.value
        if (parseFloat(e.target.value) > parseFloat(sellerPOItemQty)) {
            dispatch(raiseToast({ severity: 'error', detail: `Max quantity available is ${sellerPOItemQty}`, life: 3000 }))
            updatedValue = parseFloat(sellerPOItemQty)
        }
        handleSellerPOsChange(id, e.target.name, updatedValue)
    }

    return (
        <>
            {
                sellerPOs.map((eachSelPO, index) => {
                    let displayLabel = false
                    if (index === 0) {
                        displayLabel = true
                    }

                    return (
                        <div className="flex flex-row" key={`sellerPO-${eachSelPO.tempSellerPOId}`}>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <TextInputField name="sellerPODocNo" labelText={displayLabel && "Sel PO Doc No"} value={eachSelPO.sellerPODocNo} keyfilter={"pnum"} disabled required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                <TextInputField name="price" labelText={displayLabel && "Price"} value={eachSelPO.unitPrice} keyfilter={"pnum"} disabled required />
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 lg:mb-0">
                                <DropDownField name="GSTRate" options={GSTRates} value={eachSelPO.GSTRate} labelText={displayLabel && "GST"} optionValue="GSTRate" optionLabel="GSTRateStr" disabled required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                <TextInputField name="sellerPOItemQty" labelText={displayLabel && "Sel PO Qty"} value={eachSelPO.sellerPOItemQty} keyfilter={"pnum"} disabled required />
                            </div>
                            {/* <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                <TextInputField name="stockWarehouseQty" labelText={displayLabel && "Current stock"} value={eachSelPO.stockWarehouseQty} keyfilter={"pnum"} disabled required />
                            </div> */}
                            <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                <TextInputField name="adjustedQty" labelText={displayLabel && "Adjusted Qty"} value={eachSelPO.adjustedQty} keyfilter={"pnum"} onChange={(e) => {handleAdjustedQtyChange(eachSelPO.tempSellerPOId, e, eachSelPO.sellerPOItemQty)}} required />
                            </div>
                        </div>
                    )
                })
            }
        </>
    )
}

export default NegativeAdjDisplay